
import { useTranslations } from '@/hooks/useTranslations';

export const useMessagesTranslations = () => {
  const { t, loading } = useTranslations('messages');
  return { t, loading };
};
